import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Box,
  CircularProgress,
  makeStyles,
  MenuItem
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Autocomplete from "@material-ui/lab/Autocomplete";
import NumberFormat from "react-number-format";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import { format } from "date-fns";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Slide from "@material-ui/core/Slide";
import axios from "axios";
import api from "../common/api";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const NumericInput = React.forwardRef((props, ref) => {
  const { onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      thousandSeparator=","
      decimalSeparator="."
      decimalScale={2}
      fixedDecimalScale
      prefix="$"
    />
  );
});

const useStyles = makeStyles(theme => ({
  option: {
    fontSize: "0.75rem",
    minHeight: "auto",
    '&[aria-selected="true"]': {
      backgroundColor: "rgba(0, 0, 0, 0.08)"
    },
    '&[data-focus="true"]': {
      backgroundColor: "rgba(0, 0, 0, 0.04)"
    }
  },
  input: {
    fontSize: "0.75rem"
  }
}));

export default function Invoice({ id, client_id, booking_id }) {
  const classes = useStyles();
  const [invoice, setInvoice] = useState({
    id: id,
    invoice_type_id: "",
    invoice_point_of_sale_id: "",
    invoice_date: format(new Date(), "yyyy-MM-dd"),
    due_date: format(new Date(), "yyyy-MM-dd"),
    user_sales_id: "",
    pyme_invoice_type: "SCA",
    booking_id: booking_id ? booking_id : "",
    client_id: null,
    item_total: 0,
    total: 0,
    can_edit: true,
    can_create_credit_note: false,
    creator: {
      name: "",
      email: ""
    },
    tasks: [
      {
        id: 0,
        task_id: null,
        name: "",
        quantity: 1,
        unit_price: 0,
        subtotal: 0,
        client_charge: []
      }
    ]
  });
  const [invoiceTypes, setInvoiceTypes] = useState([]);
  const [pointOfSales, setPointOfSales] = useState([]);
  const [invoiceLevels, setInvoiceLevels] = useState([]);
  const [vehicles, setVehicles] = useState([]);

  const [fceMinValue, setFceMinValue] = useState(0);

  const [clients, setClients] = useState({
    options: [],
    loading: false
  });
  const [tasks, setTasks] = useState({
    options: [],
    loading: false
  });
  const [paymentDeals, setPaymentDeals] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedPaymentDeal, setSelectedPaymentDeal] = useState(null);
  const [saving, setSaving] = useState(false);
  const [snackBar, setSnackBar] = useState({});
  const [rebillDialog, setRebillDialog] = useState({
    open: false,
    message: ""
  });

  const token = localStorage.getItem("userToken");

  const getClient = async () => {
    if (client_id && client_id > 0) {
      try {
        const response = await axios.get(api.clients().get(client_id), {
          headers: { Authorization: `Bearer ${token}` }
        });
        const client_response = response.data[0];
        setSelectedClient(client_response);
        setClients(prev => ({
          ...prev,
          options: [client_response],
          loading: false
        }));
        setInvoice(prev => ({
          ...prev,
          client_id: client_response.id
        }));
      } catch (error) {
        console.error(error);
      }
    }
  };

  const getAllVehicles = async () => {
    try {
      const response = await axios.get(api.vehicles().index(), {
        headers: { Authorization: `Bearer ${token}` }
      });
      setVehicles(
        response.data.map(vehicle => ({
          id: vehicle.id,
          plate: vehicle.plate
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getVehiclesByClient = async client_id => {
    try {
      const response = await axios.get(api.clients().getVehicles(client_id), {
        headers: { Authorization: `Bearer ${token}` }
      });
      setVehicles(response.data);
      if (response.data.length == 0) {
        getAllVehicles();
      }
    } catch (error) {
      console.error(error);
      getAllVehicles();
    }
  };

  const getInvoice = async () => {
    try {
      const response = await axios.get(api.invoices().get(id), {
        headers: { Authorization: `Bearer ${token}` }
      });
      const tasks = response.data.invoice.invoice_tasks.map(task => {
        return {
          id: task.id,
          task_id: task.task_id,
          name: task.task ? task.task.task_id : "",
          quantity: task.quantity,
          unit_price: task.unit_price,
          subtotal: task.subtotal,
          description: task.description,
          vehicle_id: task.vehicle_id || null,
          booking_id: task.booking_id || null,
          vehicle: task.vehicle,
          client_charge: task.client_charge || []
        };
      });
      let invoice_response = response.data.invoice;
      invoice_response.tasks = tasks;
      setInvoice(invoice_response);
      setSelectedClient(response.data.invoice.client);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (client_id && client_id > 0) {
      getClient();
    }
  }, [client_id]);

  useEffect(() => {
    if (users && users.length > 0 && selectedClient) {
      const user = users.find(
        user => user.id === selectedClient.vendor_user_id
      );
      if (user) {
        setInvoice(prev => ({
          ...prev,
          user_sales_id: user.id
        }));
      } else {
        setInvoice(prev => ({
          ...prev,
          user_sales_id: ""
        }));
      }
    }
  }, [selectedClient, users]);

  useEffect(() => {
    if (selectedClient && selectedClient.id) {
      getVehiclesByClient(selectedClient.id);
    }
  }, [selectedClient]);

  useEffect(() => {
    if (
      parseInt(invoice.total) < parseInt(fceMinValue) &&
      selectedClient &&
      selectedClient.is_fce == true
    ) {
      setInvoice(prev => ({
        ...prev,
        invoice_point_of_sale_id: null,
        invoice_type_id: null
      }));
    }
  }, [invoice.total, selectedClient]);

  useEffect(() => {
    if (invoice.id > 0 && paymentDeals && paymentDeals.length > 0) {
      const payment_deal = paymentDeals.find(
        deal => deal.id === invoice.payment_deal_id
      );
      if (payment_deal) {
        setSelectedPaymentDeal(payment_deal);
      }

    }
  }, [invoice.id, paymentDeals]);
  useEffect(() => {
    if (!selectedClient || !paymentDeals) return;

    const payment_deal = paymentDeals.find(
      deal => deal.name === selectedClient.payment_deadline
    );

    if (payment_deal && invoice.id == 0) {
      setInvoice(prev => {
        const dueDate = new Date(
          new Date(invoice.invoice_date).getTime() +
            payment_deal.days_value * 24 * 60 * 60 * 1000
        );

        const formattedDueDate = dueDate.toISOString().split("T")[0];

        return {
          ...prev,
          due_date: formattedDueDate
        };
      });
    }
  }, [selectedClient, paymentDeals]);
  useEffect(() => {
    getTasks();
    const fetchMinFCEValue = async () => {
      const token = localStorage.getItem("userToken");
      try {
        const response = await axios.get(api.min_fce_value, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (response.data) {
          setFceMinValue(response.data.fce_minimum_amount);
        }
      } catch (error) {
        console.error(error);
      }
    };
    const fetchPaymentDeals = async () => {
      const token = localStorage.getItem("userToken");
      try {
        const response = await axios.get(api.payment_deals, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setPaymentDeals(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    const fetchInvoiceTypes = async () => {
      try {
        const response = await axios.get(api.invoice_types, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setInvoiceTypes(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchInvoiceLevels = async () => {
      try {
        const response = await axios.get(api.invoice_levels, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (response.data) setInvoiceLevels(response.data.invoice_levels);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchPointOfSales = async () => {
      try {
        const response = await axios.get(api.point_of_sales, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (response.data) setPointOfSales(response.data.points_of_sales);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchUsers = async () => {
      const token = localStorage.getItem("userToken");
      try {
        const response = await axios.get(api.sales_users, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setUsers(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchPaymentDeals();
    fetchInvoiceTypes();
    fetchPointOfSales();
    fetchInvoiceLevels();
    fetchMinFCEValue();
    fetchUsers();
    if (id > 0) {
      getInvoice();
    }
  }, []);

  const handleAddTask = () => {
    const newTask = {
      id: 0,
      task_id: "",
      name: "",
      quantity: 1,
      unit_price: 0,
      subtotal: 0
    };

    setInvoice(prev => ({
      ...prev,
      tasks: [...prev.tasks, newTask],
      item_total: prev.item_total + newTask.subtotal,
      total: prev.total + newTask.subtotal
    }));

    setSelectedTask(null);
  };

  const handleRemoveTask = index => {
    const taskToRemove = invoice.tasks[index];
    const updatedTasks = invoice.tasks.filter((_, i) => i !== index);

    // If this was the last task, add a new empty one
    if (updatedTasks.length === 0) {
      updatedTasks.push({
        task_id: null,
        name: "",
        quantity: 1,
        unit_price: 0,
        subtotal: 0
      });
    }

    const newItemTotal = updatedTasks.reduce((sum, t) => sum + t.subtotal, 0);

    setInvoice(prev => ({
      ...prev,
      tasks: updatedTasks,
      item_total: newItemTotal,
      total: newItemTotal
    }));
  };

  const handleClientSearch = async (event, value) => {
    if (value.length > 2) {
      setClients(prev => ({ ...prev, loading: true }));
      const token = localStorage.getItem("userToken");
      try {
        const response = await axios.get(api.clients().autocomplete(value), {
          headers: { Authorization: `Bearer ${token}` }
        });
        setClients(prev => ({
          ...prev,
          options: response.data,
          loading: false
        }));
      } catch (error) {
        console.error(error);
        setClients(prev => ({ ...prev, loading: false }));
      }
    }
  };

  const handleClientChange = (event, value) => {
    setSelectedClient(value);
    setInvoice(prev => ({
      ...prev,
      client_id: value ? value.id : null
    }));
  };

  const getTasks = async () => {
    try {
      const response = await axios.get(
        api.work_order().tasks_autocomplete("", 1),
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      setTasks(prev => ({ ...prev, options: response.data, loading: false }));
    } catch (error) {
      console.error(error);
      setTasks(prev => ({ ...prev, loading: false }));
    }
  };

  const handleTaskChange = (index, field, value) => {
    const updatedTasks = [...invoice.tasks];
    const task = updatedTasks[index];

    if (field === "quantity" || field === "unit_price") {
      const quantity = field === "quantity" ? value : task.quantity;
      const unitPrice = field === "unit_price" ? value : task.unit_price;
      const subtotal = quantity * unitPrice;
      task[field] = value;
      task.subtotal = subtotal;

      const newItemTotal = updatedTasks.reduce((sum, t) => sum + t.subtotal, 0);

      setInvoice(prev => ({
        ...prev,
        tasks: updatedTasks,
        item_total: newItemTotal,
        total: newItemTotal
      }));
    } else if (
      field === "task_id" ||
      field === "name" ||
      field === "unit_price" ||
      field === "description" ||
      field === "vehicle_id"
    ) {
      task[field] = value;
      setInvoice(prev => ({
        ...prev,
        tasks: updatedTasks
      }));
    }
  };

  const handleRedirectCreditNote = () => {
    window.location.href = `/credit-note/0/${invoice.id}`;
  };
  const handleRedirectDebitNote = () => {
    window.location.href = `/debit-note/0/${invoice.id}`;
  };
  const handleClose = () => {
    window.location.href = `/invoices`;
  };

  const handleRetry = async () => {
    setSaving(true);
    try {
      const response = await axios.post(
        api.invoices().retry(invoice.id),
        {},
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      if (response.status === 200) {
        var data = response.data[0];
        if (data.error != "" && data.sap_error !== "") {
          setSnackBar({
            open: true,
            severity: "error",
            message: data.sap_error ? data.sap_error : data.error
          });
        } else {
          setSnackBar({
            open: true,
            severity: "success",
            message: "Factura reintentada correctamente"
          });
        }
      }
    } catch (error) {
      let error_message = "Error al reintentar la factura";
      if (error.response && error.response.data) {
        for (const key in error.response.data.errors) {
          error_message += ` ${error.response.data.errors[key]}`;
        }
      }
      if (error.response.data && error.response.data.sap_error)
        error_message = error.response.data.sap_error;
      console.error(error);
      setSnackBar({
        open: true,
        severity: "error",
        message: error_message
      });
    }
    setSaving(false);
  };

  const handleConfirmRebill = async () => {
    setRebillDialog({
      open: !rebillDialog.open,
      message: "¿Esta seguro que desea refacturar esta factura?"
    });
  };
  const handleRebill = async () => {
    setRebillDialog({ open: false, message: "" });
    setSaving(true);
    try {
      const formData = new FormData();
      formData.append("invoice_id", invoice.id);
      const response = await axios.post(
        api.invoices().rebill(invoice.id),
        formData,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      if (response.status === 200) {
        setSnackBar({
          open: true,
          severity: "success",
          message: "Factura refacturada correctamente"
        });
      }
    } catch (error) {
      let error_message = "Error al refacturar la factura";
      if (error.response && error.response.data) {
        for (const key in error.response.data.errors) {
          error_message += ` ${error.response.data.errors[key]}`;
        }
      }
      if (error.response.data && error.response.data.sap_error)
        error_message = error.response.data.sap_error;
      console.error(error);
      setSnackBar({
        open: true,
        severity: "error",
        message: error_message
      });
    }
  };
  const handleDownloadClientCharges = async (type = "pdf") => {
    if (type == "pdf") {
      window.open(
        process.env.REACT_APP_API_URL + `invoices/${invoice.id}/export`,
        "_blank"
      );
      return;
    }
    if (type == "excel") {
      axios
        .get(api.invoices().export_excel(invoice.id), {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          window.location.href = response.data;
        })
        .catch(error => {
          alert("Falló la descarga");
        });
    }
  };
  const handleSubmit = async () => {
    setSaving(true);
    var formData = new FormData();
    formData.append(
      "invoice[invoice_type_id]",
      invoice.invoice_type_id ? invoice.invoice_type_id : ""
    );
    formData.append(
      "invoice[invoice_point_of_sale_id]",
      invoice.invoice_point_of_sale_id ? invoice.invoice_point_of_sale_id : ""
    );
    formData.append(
      "invoice[invoice_date]",
      invoice.invoice_date ? invoice.invoice_date : ""
    );
    formData.append(
      "invoice[due_date]",
      invoice.due_date ? invoice.due_date : ""
    );
    formData.append(
      "invoice[user_sales_id]",
      invoice.user_sales_id ? invoice.user_sales_id : ""
    );
    formData.append(
      "invoice[pyme_invoice_type]",
      invoice.pyme_invoice_type ? invoice.pyme_invoice_type : ""
    );
    formData.append(
      "invoice[booking_id]",
      invoice.booking_id ? invoice.booking_id : ""
    );
    formData.append(
      "invoice[client_id]",
      invoice.client_id ? invoice.client_id : ""
    );
    formData.append("invoice[level_1]", invoice.level_1 ? invoice.level_1 : "");
    formData.append("invoice[level_2]", invoice.level_2 ? invoice.level_2 : "");
    formData.append(
      "invoice[description]",
      invoice.description ? invoice.description : ""
    );
    formData.append(
      "invoice[comments]",
      invoice.comments ? invoice.comments : ""
    );

    invoice.tasks.forEach((task, index) => {
      formData.append(
        `tasks[${index}][description]`,
        task.description ? task.description : ""
      );
      formData.append(
        `tasks[${index}][task_id]`,
        task.task_id ? task.task_id : ""
      );
      formData.append(
        `tasks[${index}][quantity]`,
        task.quantity ? task.quantity : 0
      );
      formData.append(
        `tasks[${index}][unit_price]`,
        task.unit_price ? task.unit_price : 0
      );
      formData.append(
        `tasks[${index}][vehicle_id]`,
        task.vehicle_id ? task.vehicle_id : ""
      );
    });

    let url = api.invoices().post();
    if (invoice.id > 0) {
      url = api.invoices().patch(invoice.id);
      formData.set("_method", "PATCH");
      formData.append("invoice[id]", invoice.id);
    }

    try {
      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      });
      if (response.status === 200) {
        //setTask(response.data);
        let invoice = response.data.invoice;

        setSnackBar({
          open: true,
          severity: "success",
          message: `Factura cargada correctamente: ${invoice.number}`
        });
        setSelectedClient(null);
        setSelectedTask(null);
        setClients({ options: [], loading: false });
        setInvoice({
          id: id,
          invoice_type_id: "",
          invoice_point_of_sale_id: "",
          invoice_date: format(new Date(), "yyyy-MM-dd"),
          due_date: format(new Date(), "yyyy-MM-dd"),
          user_sales_id: "",
          pyme_invoice_type: "SCA",
          booking_id: "",
          client_id: null,
          can_edit: true,
          item_total: 0,
          total: 0,
          tasks: [
            {
              task_id: null,
              name: "",
              quantity: 1,
              unit_price: 0,
              subtotal: 0
            }
          ]
        });
        setSaving(false);
      }
    } catch (error) {
      let error_message = "Error al cargar la factura";
      if (error.response && error.response.data) {
        for (const key in error.response.data.errors) {
          error_message += ` ${error.response.data.errors[key]}`;
        }
      }
      if (error.response.data && error.response.data.sap_error)
        error_message = error.response.data.sap_error;
      console.error(error);
      setSnackBar({
        open: true,
        severity: "error",
        message: error_message
      });
    }
    setSaving(false);
  };

  const handleDelete = async () => {
    if (invoice.id <= 0) {
      setSnackBar({
        open: true,
        severity: "error",
        message: "No se puede eliminar una factura que no ha sido guardada"
      });
      return;
    }
    setSaving(true);
    try {
      const response = await axios.delete(api.invoices().delete(invoice.id), {
        headers: { Authorization: `Bearer ${token}` },
        params: { "invoice[id]": invoice.id }
      });
      if (response.status === 200) {
        setSnackBar({
          open: true,
          severity: "success",
          message: "Factura eliminada correctamente"
        });
        setInvoice({
          id: 0,
          invoice_type_id: "",
          invoice_point_of_sale_id: "",
          invoice_date: format(new Date(), "yyyy-MM-dd"),
          due_date: format(new Date(), "yyyy-MM-dd"),
          user_sales_id: "",
          pyme_invoice_type: "SCA",
          booking_id: "",
          client_id: null,
          item_total: 0,
          total: 0,
          tasks: [
            {
              task_id: null,
              name: "",
              quantity: 1,
              unit_price: 0,
              subtotal: 0
            }
          ]
        });
      }
    } catch (error) {
      let error_message = "Error al eliminar la factura";
      if (error.response && error.response.data) {
        for (const key in error.response.data.errors) {
          error_message += ` ${error.response.data.errors[key]}`;
        }
      }
      if (error.response.data && error.response.data.sap_error)
        error_message = error.response.data.sap_error;
      console.error(error);
      setSnackBar({
        open: true,
        severity: "error",
        message: error_message
      });
    }
    setSaving(false);
  };

  const hasCharges = invoice.tasks.some(
    task => task.client_charge && task.client_charge.length > 0
  );
  return (
    <div>
      <Snackbar
        open={snackBar.open}
        onClose={value => setSnackBar({ ...snackBar, open: false })}
      >
        <Alert
          onClose={value => setSnackBar({ ...snackBar, open: false })}
          severity={snackBar.severity}
        >
          {snackBar.message}
        </Alert>
      </Snackbar>
      <Dialog
        open={rebillDialog.open}
        fullWidth
        aria-labelledby="responsive-dialog-title"
        onClose={e => {
          setRebillDialog({ ...rebillDialog, open: false });
        }}
        maxWidth="xl"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Confirmar refacturación"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{rebillDialog.message}</DialogContentText>
        </DialogContent>
        <DialogActions disableSpacing="false">
          <Button
            onClick={e => {
              handleRebill();
            }}
            variant="contained"
            color="primary"
          >
            Confirmar
          </Button>
          <Button
            onClick={e => {
              setRebillDialog({ ...rebillDialog, open: false });
            }}
            variant="contained"
            color="secondary"
            className="ml-2"
          >
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
      <div className="row mb-4">
        <div className="col-12 flex align-items-center d-flex justify-content-between">
          <Typography variant="h6">
            {invoice.id == 0 ? "Crear factura" : invoice.number}
          </Typography>
          {invoice.creator && (
            <span
              style={{
                padding: "2px 8px",
                borderRadius: "4px",
                backgroundColor: "red",
                fontSize: "0.6rem",
                color: "white",
                marginLeft: "10px"
              }}
            >
              Creado por: {invoice.creator.name}
            </span>
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-md-2">
          <TextField
            fullWidth
            label="Tipo de Factura"
            select
            value={invoice.invoice_type_id}
            onChange={e =>
              setInvoice({
                ...invoice,
                invoice_type_id: e.target.value,
                invoice_point_of_sale_id: null
              })
            }
            SelectProps={{
              native: true
            }}
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              style: { fontSize: "0.75rem" }
            }}
          >
            <option value="">Seleccionar tipo</option>
            {invoiceTypes.map(type => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </TextField>
        </div>
        <div className="col-md-2">
          <TextField
            fullWidth
            label="Punto de Venta"
            select
            value={invoice.invoice_point_of_sale_id}
            onChange={e =>
              setInvoice({
                ...invoice,
                invoice_point_of_sale_id: e.target.value
              })
            }
            SelectProps={{
              native: true
            }}
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              style: { fontSize: "0.75rem" }
            }}
          >
            <option value="">Seleccionar tipo</option>
            {pointOfSales
              .filter(p => p.invoice_type_id == invoice.invoice_type_id)
              .map(pos => (
                <option key={pos.id} value={pos.id}>
                  {pos.description} ({pos.sap_code})
                </option>
              ))}
          </TextField>
        </div>
        <div className="col-md-2">
          <TextField
            fullWidth
            label="Fecha"
            type="date"
            value={invoice.invoice_date}
            onChange={e =>
              setInvoice({ ...invoice, invoice_date: e.target.value })
            }
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              style: { fontSize: "0.75rem" }
            }}
          />
        </div>
        <div className="col-md-2">
          <TextField
            fullWidth
            label="Vencimiento"
            type="date"
            value={invoice.due_date}
            onChange={e => setInvoice({ ...invoice, due_date: e.target.value })}
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              style: { fontSize: "0.75rem" }
            }}
          />
        </div>
        <div className="col-md-2">
          <TextField
            fullWidth
            label="Vendedor"
            select
            value={invoice.user_sales_id}
            onChange={e =>
              setInvoice(prev => ({ ...prev, user_sales_id: e.target.value }))
            }
            SelectProps={{
              native: true
            }}
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              style: { fontSize: "0.75rem" }
            }}
          >
            <option value="">Seleccionar vendedor</option>
            {users.map(user => (
              <option key={user.id} value={user.id}>
                {user.name}
              </option>
            ))}
          </TextField>
        </div>
        <div className="col-md-1">
          <TextField
            fullWidth
            label="Tipo PYME"
            select
            value={invoice.pyme_invoice_type}
            onChange={e =>
              setInvoice({ ...invoice, pyme_invoice_type: e.target.value })
            }
            SelectProps={{
              native: true
            }}
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              style: { fontSize: "0.75rem" }
            }}
          >
            <option value="SCA">SCA</option>
            <option value="ADC">ADC</option>
          </TextField>
        </div>
        <div className="col-md-1">
          <TextField
            fullWidth
            label="Reserva"
            value={invoice.booking_id}
            onChange={e =>
              setInvoice({ ...invoice, booking_id: e.target.value })
            }
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              style: { fontSize: "0.75rem" }
            }}
          />
        </div>
        {invoice.id == 0 && client_id == 0 && (
          <div className="col-md-4 mt-2">
            <Autocomplete
              options={clients.options}
              getOptionLabel={option => option.business_name}
              getOptionSelected={(option, value) => option.id === value.id}
              loading={clients.loading}
              onInputChange={handleClientSearch}
              onChange={handleClientChange}
              value={
                clients.options.find(
                  option => option.id === invoice.client_id
                ) || null
              }
              autoComplete
              noOptionsText={
                <Typography variant="caption">Sin resultados</Typography>
              }
              includeInputInList
              classes={{
                option: classes.option
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Cliente"
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {clients.loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                    classes: {
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              )}
            />
          </div>
        )}
        <div className="col-md-3 mt-2">
          <TextField
            id="level_1"
            name="level_1"
            label="Agrupación 1"
            value={invoice.level_1 || ""}
            onChange={e =>
              setInvoice({ ...invoice, level_1: e.target.value, level_2: "" })
            }
            select
            fullWidth
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              style: { fontSize: "0.75rem" }
            }}
            InputProps={{
              style: { fontSize: "0.75rem" }
            }}
          >
            <MenuItem value="" style={{ fontSize: "0.75rem" }}>
              Seleccione un nivel
            </MenuItem>
            {invoiceLevels
              .filter(i => i.level == 1)
              .map(level => (
                <MenuItem
                  key={level.id}
                  value={level.id}
                  style={{ fontSize: "0.75rem" }}
                >
                  {level.name}
                </MenuItem>
              ))}
          </TextField>
        </div>
        <div className="col-md-3 mt-2">
          <TextField
            id="level_2"
            name="level_2"
            label="Agrupación 2"
            value={invoice.level_2 || ""}
            onChange={e => setInvoice({ ...invoice, level_2: e.target.value })}
            select
            fullWidth
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              style: { fontSize: "0.75rem" }
            }}
            InputProps={{
              style: { fontSize: "0.75rem" }
            }}
          >
            {invoice.level_1 &&
              invoiceLevels
                .filter(
                  i =>
                    i.level == 2 &&
                    invoiceLevels
                      .find(i => i.id == invoice.level_1)
                      .sub_levels.includes(i.id)
                )
                .map(level => (
                  <MenuItem
                    key={level.id}
                    value={level.id}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {level.name}
                  </MenuItem>
                ))}
          </TextField>
        </div>
      </div>

      {selectedClient && (
        <div className="row mt-3">
          <div className="col-12">
            <Typography variant="subtitle1">
              {selectedClient.business_name} -{" "}
              {selectedClient.sap_code
                ? selectedClient.sap_code
                : "Cliente no cargado en SAP"}
            </Typography>
            {invoice.id == 0 && <Typography variant="caption">
              Plazo de pago del cliente:
              {selectedClient.payment_deadline &&
              selectedClient.payment_deadline != "undefined"
                ? selectedClient.payment_deadline
                : "Sin cargar"}
            </Typography>}
            {invoice.id > 0 && <Typography variant="caption">
              Plazo de pago:
              {selectedPaymentDeal && selectedPaymentDeal.name}
            </Typography>}

          </div>
        </div>
      )}

      <div className="row mt-3">
        <div className="col-12">
          <TextField
            id="description"
            label="Descripción"
            value={invoice.description || ""}
            onChange={e =>
              setInvoice({
                ...invoice,
                description: e.target.value
              })
            }
            fullWidth
            InputProps={{
              style: { fontSize: "0.75rem" }
            }}
            InputLabelProps={{
              shrink: true
            }}
          />
          <TableContainer className="mt-2" component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={1}>Tarea</TableCell>
                  <TableCell align="right" colSpan={1}>
                    Patente
                  </TableCell>
                  <TableCell align="right" colSpan={4}>
                    Descripción
                  </TableCell>
                  <TableCell align="right" colSpan={1}>
                    Cantidad
                  </TableCell>
                  <TableCell align="right" colSpan={2}>
                    Precio Unitario S/IVA
                  </TableCell>
                  <TableCell align="right" colSpan={2}>
                    Subtotal S/IVA
                  </TableCell>
                  <TableCell align="right">
                    <Box display="flex" justifyContent="flex-end">
                      <IconButton
                        color="primary"
                        onClick={handleAddTask}
                        size="small"
                      >
                        <AddIcon />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoice.tasks.map((task, index) => (
                  <TableRow key={index}>
                    <TableCell colSpan={1}>
                      {!task.name && invoice.id == 0 && (
                        <TextField
                          id={`task-${index}`}
                          value={task.task_id || ""}
                          onChange={e =>
                            handleTaskChange(index, "task_id", e.target.value)
                          }
                          select
                          placeholder="Ingrese una tarea"
                          InputProps={{
                            style: { fontSize: "0.75rem", maxWidth: "200px" }
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                        >
                          <MenuItem value="" style={{ fontSize: "0.75rem" }}>
                            Seleccione una tarea
                          </MenuItem>
                          {tasks.options.map(option => (
                            <MenuItem
                              key={option.id}
                              value={option.id}
                              style={{ fontSize: "0.75rem" }}
                            >
                              {option.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      )}
                      {invoice.id > 0 && (
                        <TextField
                          id={`task-${index}`}
                          value={task.task_id || ""}
                          onChange={e =>
                            handleTaskChange(index, "task_id", e.target.value)
                          }
                          disabled={task.id > 0 ? true : false}
                          select
                          placeholder="Ingrese una tarea"
                          InputProps={{
                            style: { fontSize: "0.75rem" }
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                        >
                          <MenuItem value="" style={{ fontSize: "0.75rem" }}>
                            Seleccione una tarea
                          </MenuItem>
                          {tasks.options.map(option => (
                            <MenuItem
                              key={option.id}
                              value={option.id}
                              style={{ fontSize: "0.75rem" }}
                            >
                              {option.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      )}
                    </TableCell>
                    <TableCell align="right" colSpan={1}>
                      {task.task_id && task.id == 0 && (
                        <Autocomplete
                          id={`vehicle_id-${index}`}
                          options={vehicles}
                          getOptionLabel={option => option.plate || ""}
                          isOptionEqualToValue={(option, value) =>
                            option.id === value.id
                          }
                          value={
                            vehicles.find(v => v.id === task.vehicle_id) || null
                          }
                          onChange={(event, newValue) => {
                            if (newValue && newValue.id) {
                              handleTaskChange(
                                index,
                                "vehicle_id",
                                newValue.id || ""
                              );
                            }
                          }}
                          classes={{
                            option: classes.option
                          }}
                          disabled={task.id > 0}
                          fullWidth
                          renderInput={params => (
                            <TextField
                              {...params}
                              fullWidth
                              name="vehicle_id"
                              InputLabelProps={{ shrink: true }}
                              inputProps={{
                                ...params.inputProps,
                                style: { fontSize: "0.75rem" }
                              }}
                              InputProps={{
                                ...params.InputProps,
                                style: { fontSize: "0.75rem" }
                              }}
                            />
                          )}
                        />
                      )}
                      {invoice.id > 0 && task.vehicle && (
                        <TextField
                          id={`vehicle_id-${index}`}
                          name={`vehicle_id-${index}`}
                          value={task.vehicle.plate || ""}
                          disabled={task.id > 0 ? true : false}
                          InputProps={{
                            style: { fontSize: "0.75rem", maxWidth: "200px" }
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                      )}
                    </TableCell>

                    <TableCell align="right" colSpan={4}>
                      <TextField
                        type="text"
                        fullWidth
                        value={task.description ? task.description : ""}
                        disabled={invoice.id > 0 && task.id > 0}
                        onChange={e =>
                          handleTaskChange(index, "description", e.target.value)
                        }
                        InputProps={{
                          style: { fontSize: "0.75rem" }
                        }}
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </TableCell>

                    <TableCell align="right" colSpan={1}>
                      {task.task_id && (
                        <TextField
                          type="number"
                          value={task.quantity}
                          onChange={e =>
                            handleTaskChange(
                              index,
                              "quantity",
                              parseFloat(e.target.value)
                            )
                          }
                          inputProps={{
                            min: 1,
                            style: { fontSize: "0.75rem", width: "60px" }
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                      )}
                    </TableCell>
                    <TableCell align="right" colSpan={2}>
                      {task.task_id && (
                        <TextField
                          value={task.unit_price}
                          onChange={e =>
                            handleTaskChange(
                              index,
                              "unit_price",
                              parseFloat(e.target.value)
                            )
                          }
                          InputProps={{
                            inputComponent: NumericInput
                          }}
                          inputProps={{
                            style: {
                              fontSize: "0.75rem",
                              width: "100px",
                              textAlign: "right"
                            }
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                      )}
                    </TableCell>
                    <TableCell align="right" colSpan={2}>
                      {task.task_id && (
                        <NumberFormat
                          value={task.subtotal}
                          displayType="text"
                          thousandSeparator=","
                          decimalSeparator="."
                          decimalScale={2}
                          fixedDecimalScale
                          prefix="$"
                          style={{ fontSize: "0.75rem" }}
                        />
                      )}
                    </TableCell>
                    <TableCell align="right">
                      {task.task_id && (
                        <IconButton
                          onClick={() => handleRemoveTask(index)}
                          size="small"
                        >
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell colSpan={12}>
                    <TextField
                      id="comments"
                      label="Comentarios"
                      value={invoice.comments || ""}
                      onChange={e =>
                        setInvoice({
                          ...invoice,
                          comments: e.target.value
                        })
                      }
                      fullWidth
                      InputProps={{
                        style: { fontSize: "0.75rem" }
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-12">
          <Box display="flex" justifyContent="flex-end">
            <Box mr={2}>
              <Typography variant="subtitle2">
                Total:{" "}
                <NumberFormat
                  value={invoice.total}
                  displayType="text"
                  thousandSeparator=","
                  decimalSeparator="."
                  decimalScale={2}
                  fixedDecimalScale
                  prefix="$"
                />
              </Typography>
            </Box>
          </Box>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-12">
          <Button onClick={handleClose} color="secondary" size="small">
            {invoice.id == 0 ? "Cancelar" : "Volver"}
          </Button>
          {invoice.can_edit == true && invoice.id > 0 && (
            <>
              {" "}
              <Button
                onClick={() => handleDelete()}
                color="secondary"
                size="small"
                className="mr-2"
                variant="outlined"
              >
                Eliminar
              </Button>
            </>
          )}
          {invoice.can_edit == true && (
            <Button
              onClick={handleSubmit}
              disa
              color="primary"
              variant="contained"
              className="mr-2"
              disabled={saving}
              size="small"
            >
              Guardar
            </Button>
          )}

          {invoice.id > 0 &&
            invoice.status == "generated" &&
            invoice.can_create_credit_note && (
              <Button
                onClick={handleRedirectCreditNote}
                color="primary"
                variant="contained"
                disabled={saving}
                size="small"
                className="mr-2"
              >
                Generar Nota Crédito
              </Button>
            )}
          {invoice.id > 0 &&
            invoice.status == "generated" &&
            invoice.can_create_credit_note && (
              <Button
                onClick={handleRedirectDebitNote}
                color="primary"
                variant="contained"
                disabled={saving}
                size="small"
                className="mr-2"
              >
                Generar Nota Débito
              </Button>
            )}
          {invoice.id > 0 && invoice.can_edit == true && (
            <Button
              onClick={handleRetry}
              color="primary"
              variant="contained"
              disabled={saving}
              size="small"
              className="mr-2"
            >
              Reintentar
            </Button>
          )}
          {hasCharges && (
            <>
              <Button
                onClick={() => {
                  handleDownloadClientCharges("pdf");
                }}
                color="primary"
                variant="outlined"
                size="small"
                className="mr-2"
              >
                Cargos (pdf)
              </Button>

              <Button
                onClick={() => {
                  handleDownloadClientCharges("excel");
                }}
                color="primary"
                variant="outlined"
                size="small"
                className="mr-2"
              >
                Cargos (excel)
              </Button>
            </>
          )}
          {invoice.id > 0 &&
            invoice.status == "generated" &&
            invoice.can_create_credit_note && (
              <Button
                onClick={handleConfirmRebill}
                color="primary"
                variant="contained"
                disabled={saving}
                size="small"
                className="mr-2"
              >
                Refacturar
              </Button>
            )}
        </div>
      </div>
    </div>
  );
}
